import dynamic from 'next/dynamic';

import { mdComponents } from './docMd';

const TextStatement = dynamic(
  () => import('@collab/molecules/TextStatement/TextStatement'),
);
const Tab = dynamic(() => import('./Tab'));
const Tabs = dynamic(() => import('./Tabs'));
const Tags = dynamic(() => import('./Tags'));
const Endpoint = dynamic(() => import('./Endpoint'));
const Scopes = dynamic(() => import('./Scopes'));
const HeadersInfo = dynamic(() => import('./HeadersInfo'));
const FeatureFlagged = dynamic(() => import('./FeatureFlagged'));
const Link = dynamic(() => import('./Link'));
const Warning = dynamic(() => import('./WarningBlock'));
const Info = dynamic(() => import('./InfoBlock'));
const SmallInfoNotice = dynamic(() => import('./SmallInfoNotice'));

export const mdxComponents: any = {
  ...mdComponents,
  Link,
  TextStatement,
  FeatureFlagged,
  Tabs,
  Tab,
  Endpoint,
  Scopes,
  HeadersInfo,
  SmallInfoNotice,
  Info,
  Tags,
  Warning,
};
